/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/

import React, { useEffect, useState, Suspense, lazy } from "react";
import "./App.css";
import Loader from "./components/PostEvent/Loader";
import MediaQuery from "react-responsive";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import { CookieSetting } from "cookiesetting-component";
import appversion from "../package.json";
import data from "../../post-event/src/components/PostEvent/PostEventMemories/data.json";
import jsonData from "./ai-branding.json"; // Import the JSON file
const Body = lazy(() => import("./components/PostEvent/Body/Body"));
const BodyMobile = lazy(() => import("./components/PostEvent/Body/Bodymobile"));
const LogoMobile = lazy(() =>
  import("./components/PostEvent/Logo Section/Logomobile.js")
);
const Logo = lazy(() => import("./components/PostEvent/Logo Section/Logo.js"));
const Footer = lazy(() => import("./components/PostEvent/Footer/Footer"));
const SignUpForm = lazy(() =>
  import("./components/PostEvent/ContactUS/SignUpForm.js")
);
const Video = lazy(() => import("./components/PostEvent/video.js"));
const ExploreSection = lazy(() =>
  import("./components/PostEvent/VideoSection/ExploreSection.js")
);
const SocialPost = lazy(() =>
  import("./components/PostEvent/PostSocial/SocialPic.js")
);

const Eventmemomonile = lazy(() =>
  import("./components/PostEvent/Recapingmemories/PostEventMemories")
);
const Thankyou = lazy(() =>
  import("./components/PostEvent/ThankYou/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import(
    "./components/PostEvent/SubscribeNotification/SubscribeForEventNotifications.js"
  )
);
const VideoHighlights = lazy(() =>
  import("./components/PostEvent/VideoHighlights/VideoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("./components/PostEvent/MemoryHighlight/MemoriesHighlight.js")
);

const PostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/Videos.js")
);

const Recaping = lazy(() =>
  import("./components/PostEvent/Recapingmemories/Recapingmemories.js")
);

// const Mobilerecaping = lazy(() =>
//   import("./components/PostEvent/Recapingmemories/Mobilerecaping.js")
// );



function App() {

  const [links, setLinks] = useState(null); // Set initial state as null
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  const appVersion = appversion.version;
  return (
    <div className="bodyContainer">
       {links ? (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
      >
        <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
        <MediaQuery minWidth={992}>
          <Suspense fallback={<div />}>
            <Body handleVideo={handleVideo} videoToggle={videoToggle}  links={links.current} />
          </Suspense>
        </MediaQuery>
        <MediaQuery maxWidth={991}>
          <Suspense fallback={<div />}>
            <BodyMobile handleVideo={handleVideo} videoToggle={videoToggle}  links={links.current}/>
          </Suspense>
        </MediaQuery>

        <Suspense fallback={<div />}>
          <Logo />
        </Suspense>

        <MediaQuery maxWidth={991}>
          <Suspense fallback={<div />}>
            <SignUpForm />
          </Suspense>
        </MediaQuery>
        {/* <MediaQuery minWidth={993}>
        <Suspense fallback={<div />}>
          <EventMemories />
        </Suspense>
      </MediaQuery>
        <MediaQuery maxWidth={992}>
        <Suspense fallback={<div />}>
          <EventMemoriesMobile />
        </Suspense>
      </MediaQuery> */}
        <Suspense fallback={<div />}>
            <ExploreSection />
          </Suspense>

        <MediaQuery minWidth={993}>
          <Suspense fallback={<div />}>
            <Recaping />
          </Suspense>
        </MediaQuery>

        <MediaQuery maxWidth={992}>
          <Suspense fallback={<div />}>
            <Eventmemomonile />
          </Suspense>
        </MediaQuery>
        <Suspense fallback={<div />}>
          <SocialPost />
        </Suspense>

        <Suspense fallback={<div />}>
          <Thankyou />
        </Suspense>
        <Suspense fallback={<div />}>
          <SubscribeForEventNotifications />
        </Suspense>
        <Suspense fallback={<div />}>
          <VideoHighlights />
        </Suspense>
        <Suspense fallback={<div />}>
          <MemoriesHighlights links={links.current}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
        <Suspense fallback={<Loader />}>
          {played && (
            <Video handleVideo={handleVideo} videoToggle={videoToggle} />
          )}
        </Suspense>
      </CacheBuster>
      </>
    ) : (
      <div>Loading...</div>
    )}
    </div>
  );
}

export default App;
